import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import SuccessSvg from "@icons/myicons/check-circle-filled.svg?react";
import { Account } from "@rentablo/api/apiv1";
import { LoadingSpinner } from "@rentablo/components";

const AccountContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px ${({ theme }) => theme.palette.border.secondary};
  padding: ${({ theme }) => theme.spacing(2, 0)};

  &:first-of-type {
    border-top: solid 1px ${({ theme }) => theme.palette.border.secondary};
  }
`;

export interface Props {
  accounts: Account[];
}

export const AccountList = ({ accounts }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (!accounts.length) {
    return (
      <AccountContainer key="accounts-initializing">
        <Typography variant="body1">
          {t("netfondsConsent.importingData")}
        </Typography>
        <LoadingSpinner width={25} />
      </AccountContainer>
    );
  }

  return (
    <Box>
      {accounts.map((account) => {
        return (
          <AccountContainer key={`account-${account.id}`}>
            <Typography variant="body1">{account.name}</Typography>
            {!account.lastSyncDate && (
              <LoadingSpinner
                testId={`account-${account.id}-importing`}
                width={25}
              />
            )}
            {account.lastSyncDate && (
              <SuccessSvg
                width="30px"
                height="30px"
                data-testid={`account-${account.id}-imported`}
                color={theme.palette.icon.success}
              />
            )}
          </AccountContainer>
        );
      })}
    </Box>
  );
};
